import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CitronellaActionsService } from 'src/app/features/shared/services/ServiceCatalogEncapsulators/CitronellaActions.service';
import { CarouselPopupComponent } from '../../atoms/carousel-popup/carousel-popup.component';

@Component({
  selector: 'carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.css']
})
export class CarouselComponent {

  @Input() images : string[] = []; // Rutas de las imágenes precargadas
  @Input() identifier : string = '';
  @Input() idLocationCategory : number = 0;

  @Output() hasImages = new EventEmitter<boolean>();
  isLoading: boolean = false;
  index = 0;

  constructor(public dialog: MatDialog,
    private citronellaActionsService: CitronellaActionsService,
    ){ 
  }

  ngOnInit(): void {
    if (this.images.length == 0 && this.identifier.length > 0) {
      this.getImages();
    }
  }

  next() {
    this.index = (this.index + 1) % this.images.length;
  }

  prev() {
    this.index = (this.index - 1 + this.images.length) % this.images.length;
  }

  selectSlide(i: number) {
    this.index = i;
  }

  openPopup() {
    const diag = this.dialog.open(CarouselPopupComponent, {
      width: '60vw',
      height: 'fit-content',
      data: { 
        images: this.images,
        currentIndex: this.index,
      },
      // panelClass: 'custom-dialog-container'
    });

    diag.backdropClick().subscribe(result => {
      diag.close();
    });
  }

  async getImages() {
    this.isLoading = true;
    if (this.identifier.length == 0 || this.idLocationCategory == 0) {
      this.hasImages.emit(false);
      this.isLoading = false;
      return;
    }

    try {
      const images = await this.citronellaActionsService.GetExternalImages(this.idLocationCategory, this.identifier);
      if (images.length > 0) {
        this.images = images;
        this.hasImages.emit(true);
      } else {
        this.hasImages.emit(false);
      }
    } catch (error) {
      console.error("Error fetching images:", error);
      this.hasImages.emit(false);
      this.isLoading = false;
      return;
    }
    
    this.isLoading = false;
    // this.citronellaActionsService.getLocationImages(this.identifier).subscribe((data) => {
    //   if (data.isSuccess) {
    //     if (data.result != null){
    //       this.images = data.result;
    //       this.hasImages.emit(true);
    //     }else{
    //       this.images = [];
    //       this.hasImages.emit(false);
    //     }
    //     this.isLoading = false;
    //   }else{
    //     this.images = [];
    //     this.hasImages.emit(false);
    //     this.isLoading = false;
    //   }
    // });
    //imagenes dummy
    // this.images = ["https://lh3.googleusercontent.com/p/AF1QipPHO6GCOsXwuwK0BzvFEIx7mxT85ahvQMyumPzl=w203-h114-k-no",
    //               "https://lh3.googleusercontent.com/gps-cs-s/AC9h4npqk0RuRcOLanm7hR_bGgGo916i_WywdwhudxLb_zJFQLf3m_CgrJF6_8OWD3MArjqLNS8PF5QRHv7T-Xzk25mYIz3AmC3JpOEzNuMH52c__5PbZnq4iSGrV_LDoTbfcQQDczE=w203-h360-k-no"
    // ];
  }

}
